import { useState, useEffect } from 'react';

type UseWindowResizeReturnType = {
  isMobileSize: boolean;
};

export const useWindowResize = (size = 768): UseWindowResizeReturnType => {
  // Mobile browsers can enlarge innerWidth to fit overflowing content. Use the
  // CSS viewport so a desktop layout cannot keep itself active after rotation.
  const [isMobileSize, setIsMobileSize] = useState<boolean>(
    () => window.matchMedia(`(max-width: ${size}px)`).matches
  );

  useEffect(() => {
    const media = window.matchMedia(`(max-width: ${size}px)`);
    const updateWindowWidth = () => setIsMobileSize(media.matches);
    updateWindowWidth();
    media.addEventListener('change', updateWindowWidth);

    return () => media.removeEventListener('change', updateWindowWidth);
  }, [size]);

  return { isMobileSize };
};
